// extracted by mini-css-extract-plugin
module.exports = {"card":"index-module--card--1KEGO","post_title":"index-module--post_title--jdF4S","divide":"index-module--divide--3--ux"};